'use client';

import { Button } from '@ahafood/ui/components/button';

interface ChatSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  isLoading?: boolean;
}

export function ChatSuggestions({
  suggestions,
  onSuggestionClick,
  isLoading = false,
}: ChatSuggestionsProps) {
  return (
    // <div className="p-4">

    <div className="flex gap-3 pt-4 pb-2 px-4 overflow-x-auto scrollbar-hide">
      {suggestions?.map((suggestion, i) => (
        <Button
          key={i}
          variant="outline"
          className="rounded-xl shadow-sm bg-white md:bg-white/30 hover:bg-white border border-neutral-10 flex items-start flex-col px-3 py-2 cursor-pointer hover:shadow-md gap-2 w-auto h-full"
          onClick={() => onSuggestionClick(suggestion)}
          disabled={isLoading}
        >
          {/* <Badge
            variant="secondary"
            className="flex items-center text-xs pl-1 py-1 bg-gradient-to-r from-blue-60 via-primary-50 to-primary-50 bg-clip-text text-transparent"
          >
            <Image
              src="/static/images/new-ai.png"
              alt="AI Bot"
              width={16}
              height={16}
              className="size-4 mr-1 object-contain"
            />
            AI Đề xuất
          </Badge> */}
          <span className="text-sm font-thin text-left text-neutral-90 line-clamp-1">
            {suggestion}
          </span>
        </Button>
      ))}
    </div>
    // </div>
  );
}
